import {
  SharingScheduleRuleTimeFrames,
  SharingScheduleRuleTimeframeLabelMap,
  SharingScheduleRules,
  SharingScheduleRulesLabelsMap
} from "../../../constants";

export const RULES_OPTIONS = [
  {
    label: SharingScheduleRulesLabelsMap.BestSellingProducts,
    value: SharingScheduleRules.BestSellingProducts
  },
  {
    label: SharingScheduleRulesLabelsMap.ProductsLessThanTenInStock,
    value: SharingScheduleRules.ProductsLessThanTenInStock
  },
  {
    label: SharingScheduleRulesLabelsMap.MostSharedProducts,
    value: SharingScheduleRules.MostSharedProducts
  },
  {
    label: SharingScheduleRulesLabelsMap.HighlyRatedProducts,
    value: SharingScheduleRules.HighlyRatedProducts
  },
  {
    label: SharingScheduleRulesLabelsMap.MostWishedProducts,
    value: SharingScheduleRules.MostWishedProducts
  },
  {
    label: SharingScheduleRulesLabelsMap.MostSearchedProducts,
    value: SharingScheduleRules.MostSearchedProducts
  },
  {
    label:
      SharingScheduleRulesLabelsMap.ProductsThatExperiencedSuddenIncreaseInSales,
    value: SharingScheduleRules.ProductsThatExperiencedSuddenIncreaseInSales
  },
  {
    label: SharingScheduleRulesLabelsMap.PopularProductsThatWereRestocked,
    value: SharingScheduleRules.PopularProductsThatWereRestocked
  },
  {
    label: SharingScheduleRulesLabelsMap.HighCartAbandonmentRate,
    value: SharingScheduleRules.HighCartAbandonmentRate
  },
  {
    label: SharingScheduleRulesLabelsMap.ManualSelectionOfProducts,
    value: SharingScheduleRules.ManualSelectionOfProducts
  }
];

export const RULE_TIMEFRAME_OPTIONS = [
  {
    label: SharingScheduleRuleTimeframeLabelMap.ForAllTime,
    value: SharingScheduleRuleTimeFrames.ForAllTime
  },
  {
    label: SharingScheduleRuleTimeframeLabelMap.OverPastDay,
    value: SharingScheduleRuleTimeFrames.OverPastDay
  },
  {
    label: SharingScheduleRuleTimeframeLabelMap.OverPastWeek,
    value: SharingScheduleRuleTimeFrames.OverPastWeek
  },
  {
    label: SharingScheduleRuleTimeframeLabelMap.OverPastMonth,
    value: SharingScheduleRuleTimeFrames.OverPastMonth
  },
  {
    label: SharingScheduleRuleTimeframeLabelMap.OverPastYear,
    value: SharingScheduleRuleTimeFrames.OverPastYear
  }
];
